import {i18n} from '@/plugins/i18n'

export const subjectTypes = {
    WAGE_CHANGE: 1,
    LEVEL_CHANGE: 2,
};

export const subjectTypeStr = {
    WAGE_CHANGE: i18n.t('customers_club.wage_change'),
    LEVEL_CHANGE: i18n.t('customers_club.level_change'),

    get(type) {
        let type_str = null;

        Object.keys(subjectTypes).forEach(item => {
            if (subjectTypes[item] === type) {
                type_str = subjectTypeStr[item];
            }
        });

        return type_str;
    }
};
